import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Sélecteur réutilisable de campagne (hub « Planificateur annuel »).
// Optionnel : « Aucune campagne » = null.
export function CampaignSelect({
  value,
  onChange,
  className = "",
  labelClassName = "",
  label = "Campagne",
  testid = "campaign-select",
}) {
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    api
      .get("/campaigns")
      .then((r) => {
        const rows = Array.isArray(r.data) ? r.data : r.data?.campaigns || [];
        setCampaigns(rows);
      })
      .catch(() => {});
  }, []);

  return (
    <div>
      {label && (
        <label className={labelClassName || "text-xs uppercase text-zinc-500 block mb-1"}>
          {label}
        </label>
      )}
      <select
        data-testid={testid}
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        className={
          className ||
          "w-full bg-zinc-950 border border-zinc-700 rounded-lg px-3 py-2 text-sm text-zinc-100 focus:border-amber-500 focus:outline-none"
        }
      >
        <option value="">Aucune campagne</option>
        {campaigns.map((c) => (
          <option key={c.id} value={c.id}>
            {c.nom} · {c.annee} · {c.saison}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CampaignSelect;
